// eslint-disable-next-line
export function setMapDisplay({ commit }, payload) {
  const { mapDisplay } = payload;
  // commit the change
  commit('setMapDisplay', mapDisplay);
}

export function setPanelView({ commit }, payload) {
  const { community, panelView, quickMoveIn } = payload;
  // commit the change
  commit('setPanelView', panelView);
  commit('setDetailedCommunity', community || false);
  commit('setDetailedQuickMoveIn', quickMoveIn || false);
}

export function setZoomToLocation({ commit }, payload) {
  const { location } = payload;
  // commit the change
  commit('setZoomToLocation', location);
}
